import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import {
  Table, Checkbox, Select,
  Divider,
} from 'antd';
import UserActions from '@Actions/userActions';
import Helpers from '@Apis/helpers';
import H3FormInput from '@Uilib/h3FormInput';
import MaskingPolicyActions from '@Actions/settings/maskingPolicyActions';
import SelectDepartment from '../../../../Common/SelectDepartment';
import documentUINamesConstant from '../../../../../apis/documentUINamesConstant';
import './style.scss';

class AccessControl extends Component {
  constructor(props) {
    super(props);
    const { user } = props;
    const documentUINames = documentUINamesConstant(user);

    this.state = {
      accessControlTableColumn: [
        {
          title: '',
          width: '160px',
          // render: (text, record) => (<H3Text text={record[0]?.replaceAll('_', ' ')?.toProperCase()} className="org-pending-po__table-text" />),
          render: (text, record) => (
            <H3Text text={record[0].toLowerCase() === 'purchase_request' ? 'material_request'.replaceAll('_', ' ')?.toProperCase() : record[0]?.replaceAll('_', ' ')?.toProperCase()} className="org-pending-po__table-text" />
          ),
        },
        {
          title: 'All Access',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Checkbox
                checked={
                  record[1]?.READ
                  && record[1]?.CREATE
                  && record[1]?.UPDATE
                  && record[1]?.DELETE
                }
                onChange={(e) => {
                  this.handleCheckChangeAll(e, record);
                }}
                //
                disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                  Helpers.permissionTypes.CREATE, user)}
              />
            );
          },
        },
        {
          title: 'Read',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  record[0]?.includes('dashboard') ? '' : (
                    <Checkbox
                      checked={record[1]?.READ}
                      onChange={(e) => this.handleCheckChange(e, record, 'READ')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>

            );
          },
        },
        {
          title: 'Write',
          render: (text, record) => {
            const { user } = this.props;
            return (

              <Fragment>
                {
                  record[0]?.includes('dashboard') ? '' : (
                    <Checkbox
                      checked={record[1]?.CREATE}
                      onChange={(e) => {
                        this.handleCheckChange(e, record, 'CREATE');
                      }}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
        {
          title: 'Update',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  record[0]?.includes('dashboard') ? '' : (
                    <Checkbox
                      checked={record[1]?.UPDATE}
                      onChange={(e) => this.handleCheckChange(e, record, 'UPDATE')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
        {
          title: 'Delete',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  record[0]?.includes('dashboard') ? '' : (
                    <Checkbox
                      checked={record[1]?.DELETE}
                      onChange={(e) => this.handleCheckChange(e, record, 'DELETE')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
        {
          title: 'Costing',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  !['manufacturing_order', 'bill_of_material'].includes(record[0]) ? '' : (
                    <Checkbox
                      checked={record[1]?.COSTING}
                      onChange={(e) => this.handleCheckChange(e, record, 'COSTING')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
      ],
      isUserReady: false,
      typesOfPermissions: ['product', 'price_list', 'inventory_indent', 'stock_transfer', 'delivery_challan', 'vendors', 'purchase_request', 'request_for_quotation', 'purchase_order', 'good_receiving', 'account_payable_invoice', 'debit_note', 'bill_of_material', 'manufacturing_order', 'factory_setup', 'quality_rules', 'quality_checks', 'customer', 'sales_estimate', 'sales_order', 'packing_slip', 'invoice', 'credit_note', 'customer_payments', 'workflow_setup', 'access_control_setup', 'user_management', 'vendor_payout', 'expenses', 'e_way_bill', 'e_invoice', 'purchase_dashboard', 'inventory_dashboard', 'production_dashboard', 'sales_dashboard', 'reports', 'material_planning', 'gate_document', 'vendor_price', 'consumption_order', 'annual_maintenance_contract', 'return_slip', 'purchase_indent'],
      otherPermission: {
        allow_all_access_to_so: {
          uiName: `Make this user ${documentUINames.salesOrderUIName} Manager`,
          uiMessage: `When ${documentUINames.salesOrderUIName}s are restricted to assignee only, then only manager can see ${documentUINames.salesOrderUIName.toLowerCase()}.`,
        },
        allow_all_access_to_invoice: {
          uiName: 'Make this user Invoice Manager',
          uiMessage: 'When Invoices are restricted to assignee only, then only manager can see Invoice.',
        },
        allow_all_access_to_estimate: {
          uiName: `Make this user ${documentUINames.estimateUIName} Manager`,
          uiMessage: `When ${documentUINames.estimateUIName}s are restricted to assignee only, then only manager can see ${documentUINames.estimateUIName.toLowerCase()}.`,
        },
        editable_material_request_qty_from_mo: {
          uiName: 'Quantity editable while creating Material Request from Manfacturing Order.',
          uiMessage: "When Material Request is created from Manufacturing Order, the user will be able to enter Product's Quantity manually. Unchecking this option will make it non-editable.",
        },
        editable_work_order_qty: {
          uiName: 'Quantity editable while creating Work Order from Manfacturing Order.',
          uiMessage: "When Work Order is created from Manufacturing Order, the user will be able to enter Product's Primary and Secondary Quantities manually. Unchecking this option will make it non-editable.",
        },
        editable_material_request_qty_from_mrp: {
          uiName: 'Quantity editable while creating Material Request from Materials Planning.',
          uiMessage: "When Material Request is created from Materials Planning, the user will be able to enter Product's Quantity manually. Unchecking this option will make it non-editable.",
        },
        editable_purchase_order_qty: {
          uiName: 'Quantity editable while creating Purchase Order from Materials Planning.',
          uiMessage: "When Purchase Order is created from Materials Planning, the user will be able to enter Product's Quantity manually. Unchecking this option will make it non-editable.",
        },
        allow_to_change_product_batches_quality : {
          uiName: 'Allow this role to change product batches quality',
          uiMessage: 'When enabled, this role will be able to change product batches quality.',
        },
      },
    };
  }

  componentDidMount() {
    const {
      user, getMaskingPolicies,
    } = this.props;
    getMaskingPolicies(user?.tenant_info?.org_id);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedPermissions?.tenant_id && !state.isUserReady) {
      return {
        ...state,
        selectedPermissions: props.selectedPermissions,
        isUserReady: true,
      };
    }
    return state;
  }

  handleCheckChange(e, record, field) {
    const { selectedPermissions } = this.state;
    const copyPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    copyPermissions[record[0]][field] = !record[1]?.[field];
    if (['CREATE', 'UPDATE'].includes(field)) copyPermissions[record[0]].COSTING = !record[1]?.[field];
    if (['COSTING'].includes(field)) {
      copyPermissions[record[0]].CREATE = !record[1]?.[field];
      copyPermissions[record[0]].UPDATE = !record[1]?.[field];
    }
    this.setState({ selectedPermissions: copyPermissions });
  }

  handleCheckChangeAll(e, record) {
    const { selectedPermissions } = this.state;
    const copyPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    copyPermissions[record[0]].READ = e.target.checked;
    copyPermissions[record[0]].CREATE = e.target.checked;
    copyPermissions[record[0]].UPDATE = e.target.checked;
    copyPermissions[record[0]].DELETE = e.target.checked;
    copyPermissions[record[0]].APPROVE = e.target.checked;
    copyPermissions[record[0]].UPLOAD = e.target.checked;
    copyPermissions[record[0]].COSTING = e.target.checked;
    this.setState({ selectedPermissions: copyPermissions });
  }

  handleOtherPermissionCheckChange(e, record) {
    const { selectedPermissions } = this.state;
    const copyPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    copyPermissions[record[0]] = !record[1];
    this.setState({ selectedPermissions: copyPermissions });
  }

  render() {
    const {
      updateRole, user, getRolesLoading, maskingPolicies,
      updateRoleLoading, callback, getUserProfile,
    } = this.props;
    const {
      accessControlTableColumn, typesOfPermissions,
      selectedPermissions, formSubmitted, selectedPolicy, otherPermission,
    } = this.state;
    return (
      <Fragment>
        <div className="update-permission__slider" style={{ paddingBottom: '50px' }}>
          <div className="update-permission__heading">
            <div className="ant-row">
              <div className="ant-col-md-12 width-50-in-mobile">
                <SelectDepartment
                  title="Select Department"
                  selectedDepartment={selectedPermissions?.tenant_department_info?.department_id}
                  onChange={(value) => {
                    this.setState({
                      selectedPermissions: {
                        ...selectedPermissions,
                        tenant_department_name: value?.alias_name,
                        tenant_department_id: value?.tenant_department_id,
                        tenant_department_info: value?.department_info,
                        department_id: value?.department_id,
                      },
                    });
                  }}
                  customStyle={{
                    width: '98%',
                  }}
                  disabled={false}
                  containerClassName="orgInputContainer department__select"
                  labelClassName="orgFormLabel"
                  emptyNotAllowed
                />
              </div>
              <div className="ant-col-md-12">
                <H3FormInput
                  name="Role Name"
                  type="text"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  placeholder=""
                  value={selectedPermissions?.tenant_role_name}
                  onChange={(e) => this.setState({
                    selectedPermissions: {
                      ...selectedPermissions,
                      tenant_role_name: e.target.value,
                    },
                  })}
                  label="Role Name"
                  maxlength="100"
                  disabled={updateRoleLoading}
                  required
                  showError={formSubmitted && !selectedPermissions?.tenant_role_name}
                />
              </div>
            </div>

          </div>
          <div className="generic-table-container show-table-header-in-mobile">
            <Table
              showHeader
              size="small"
              loading={getRolesLoading || updateRoleLoading}
              pagination={false}
              columns={accessControlTableColumn}
              dataSource={selectedPermissions
                && Object.entries(selectedPermissions)?.filter(
                  (item) => typesOfPermissions.includes(item[0]),
                )}
            // scroll={{ y: 'calc(100dvh - 230px)' }}
            scroll={{ y: 400 }}
            sticky
            />
          </div>
          <div className="other-permission-container">
            <Divider orientation="left" orientationMargin="0">Other Permissions</Divider>
            <div className="other-permission-line-container">
              {Object.entries(selectedPermissions)?.filter((item) => otherPermission[item[0]])?.map((record) => (
                <div key={record[0]} className="other-permission-line">
                  <Checkbox
                    checked={record[1]}
                    onChange={(e) => this.handleOtherPermissionCheckChange(e, record)}
                    disabled={getRolesLoading || updateRoleLoading}
                  />
                  <H3Text text={otherPermission[record[0]].uiName} className="other-permission-line-label" infoMessage={otherPermission[record[0]].uiMessage ?? false} />
                </div>

              ))}
            </div>
          </div>
        </div>
        {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
          Helpers.permissionTypes.CREATE, user) && (
          <div className="update-permission__footer">
            <H3Button
              text="Update Permissions"
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              disabled={updateRoleLoading}
              isLoading={updateRoleLoading}
              customClass="update-permission__footer-submit"
              onClick={() => {
                this.setState({ formSubmitted: true });
                if (selectedPermissions.tenant_department_name && selectedPermissions?.tenant_role_name) {
                  updateRole(selectedPermissions, () => {
                    callback();
                    getUserProfile();
                  });
                }
              }}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers, MaskingPolicyReducers,
}) => ({
  user: UserReducers.user,
  roles: UserReducers.roles,
  permissions: UserReducers.permissions,
  getRolesLoading: UserReducers.getRolesLoading,
  updateRoleLoading: UserReducers.updateRoleLoading,
  tenants: TenantReducers.tenants,
  maskingPolicies: MaskingPolicyReducers.maskingPolicies,

});

const mapDispatchToProps = (dispatch) => ({
  updateRole: (payload, callback) => dispatch(
    UserActions.updateRole(payload, callback),
  ),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
  getMaskingPolicies: (orgId, maskingPolicyId, page, limit, callback) => dispatch(MaskingPolicyActions.getMaskingPolicies(orgId, maskingPolicyId, page, limit, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccessControl));
